<template>
	<div class="downCode">
		<div class="title">
			扫码进入小程序
		</div>
		<div class="codeCon">
			<img src="@/static/qrcode.jpg" class="code" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	.downCode{
		width: 229px;
		height: 288px;
		background-image: linear-gradient(150deg,#63CBCB,#FFFFFF);
		border-radius: 8px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: space-between;
		padding: 27px 0 19px;
		box-sizing: border-box;
		.title{
			font-size: 24px;
			color: #fff;
			margin-bottom: 16px;
		}
		.codeCon{
			background-color: #fff;
			padding: 16px ;
			border-radius: 8px;
			.code{
				width:157px;
				height: 157px;
			}
		}
	}
</style>